import wos from 'apis/wos';

import type {
  CreateUserRoomPOSTData,
  RawWallPreviewUserRoom,
  SaveUserRoomPUTData,
} from 'domains/wall_preview_rooms';

export const get = async () => {
  const { data } = await wos.get<RawWallPreviewUserRoom[]>('/wall_preview_room_uploads.json');
  return data;
};

export const bulkCreate = async (rooms: CreateUserRoomPOSTData[]) => {
  const { data } = await wos.post<RawWallPreviewUserRoom[]>(
    '/wall_preview_room_uploads/bulk_create.json',
    {
      roomUploads: rooms,
    }
  );

  return data;
};

export const bulkUpdate = async (rooms: SaveUserRoomPUTData[]) => {
  const { data } = await wos.put<RawWallPreviewUserRoom[]>(
    '/wall_preview_room_uploads/bulk_update.json',
    {
      roomUploads: rooms,
    }
  );

  return data;
};

export const destroy = async (id: number) => {
  await wos.delete(`/wall_preview_room_uploads/${id}.json`);
};
